import { Component, Input } from '@angular/core';
import { map } from 'rxjs';
import { BaseComponent } from 'src/app/core/base/base.component';
import { GeneralCatalogViewModel } from 'src/app/model/general/general-catalog.view';
import { generalConsultExaminationConstants } from './examination.constants';
import { GeneralConsultExaminationService } from './examination.service';

@Component({
  selector: 'ms-consult-examination',
  templateUrl: './examination.component.html',
})
export class GeneralConsultExaminationComponent extends BaseComponent {
  readonly screen = generalConsultExaminationConstants;
  @Input() turn = -1;
  @Input() readonly = false;
  examinations: GeneralCatalogViewModel[] = [];
  mainDetail?: GeneralCatalogViewModel;
  showDetails = false;
  expandSection = true;

  constructor(protected service: GeneralConsultExaminationService) {
    super();
  }

  protected onInit() {
    this.subscriptions.push(
      this.service.getPatient().subscribe((patient) => {
        if (patient) {
          this.service
            .loadExaminations(this.turn, patient, this.readonly)
            .pipe(
              map((res) => {
                return res.map((item) => {
                  if (item.catalog) {
                    item.filled = true;
                  }
                  return item;
                });
              })
            )
            .subscribe((examinations) => {
              this.mainDetail = examinations.find(
                (item) => item.id === 'phy_exa_00'
              );
              this.examinations = examinations.filter(
                (item) => item.id !== 'phy_exa_00'
              );
            });
        }
      })
    );

    if (!this.readonly) {
      this.handleReadOnlyData();
    }
  }

  private handleReadOnlyData = () => {
    this.subscriptions.push(
      this.service.isSaving().subscribe((saving) => {
        if (saving) {
          const examinations: GeneralCatalogViewModel[] = [];
          const edited = this.examinations.filter(
            (examination) =>
              examination.details && examination.details.length > 0
          );
          if (
            this.mainDetail &&
            (this.mainDetail.details ?? '').trim().length > 0
          ) {
            for (const detail of edited) {
              const extraLabel = `; ${detail.name}`;
              this.mainDetail.details = this.mainDetail.details?.replace(
                extraLabel,
                ''
              );
            }
            examinations.push(this.mainDetail);
          }
          examinations.push(...edited);
          this.subscriptions.push(this.service.save(examinations).subscribe());
        }
      })
    );
  };

  handleUpdateGlobalField = ($ev: GeneralCatalogViewModel) => {};

  get catalogsName() {
    return this.examinations
      .filter((item) => item.details && item.details?.trim().length > 0)
      .map((item) => item.name)
      .join('; ');
  }
}
